import { CustomFile } from 'src/components/upload'

export type IUserTableFilterValue = string | string[]

export type IUserTableFilters = {
  search: string
  role: string[]
  active: string
}

export type IUserPermissions = {
  [key: string]: boolean
  budgets: boolean
  kanban: boolean
  clients: boolean
  packages: boolean
  users: boolean
  reports: boolean
  tasks: boolean
  hostings: boolean
  hostingBudgets: boolean
}

export const DEFAULT_USER_PERMISSIONS: IUserPermissions = {
  budgets: true,
  kanban: true,
  clients: true,
  packages: false,
  users: false,
  reports: false,
  tasks: true,
  hostings: true,
  hostingBudgets: true,
}

export type IUserItem = {
  _id: string
  name: string
  ddi?: string
  ddd?: string
  phone: string
  role: 'admin' | 'user'
  funcao?: 'balcao' | 'callcenter' | ''
  email: string
  active?: boolean
  password?: string
  agesType: any

  pcd?: boolean
  pcdCompanion?: boolean
  student?: boolean
  resident?: boolean

  age?: number
  createdAt: Date
  photo?: any
  permissions?: IUserPermissions
  discountMin?: number
  discountMax?: number
}

export type IUserAccount = {
  email: string
  password?: string
  name: string
  photo: CustomFile | string | null
}
